import { Component, OnInit } from '@angular/core';
import { ProductClass } from 'src/app/enums/productClass.enum';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ProductClassificationService } from 'src/app/services/product-classification.service';
import { ThreeDService } from 'src/app/services/three-d.service';

@Component({
  selector: 'app-step-two',
  templateUrl: './step-two.component.html',
  styleUrls: ['./step-two.component.scss'],
})
export class StepTwoComponent implements OnInit {
  constructor(
    private configurationService: ConfigurationService,
    private threeDService: ThreeDService,
    private productClassificationService: ProductClassificationService
  ) {}
  allowedWallThicknesses = [];
  proThicknesses: number[] = [];
  proPlusThicknesses: number[] = [];
  selectedThickness = null;
  
  ngOnInit() {
    this.threeDService.setZoom(3.75);
    this.threeDService.resetDefaultCamera();

    this.configurationService.furthestStepVisited = 2;

    this.allowedWallThicknesses = this.configurationService.allowedWallThicknesses;
    this.selectedThickness =
      this.configurationService.wallThickness || this.configurationService.allowedWallThicknesses[0];

    this.proThicknesses = this.productClassificationService.GetProWallThickness();
    this.proPlusThicknesses = this.productClassificationService.GetProPlusWallThickness();
  }

  updateThickness(value: number) {
    this.selectedThickness = value;
    this.configurationService.wallThickness = value;
    if (!this.isStandardThickness(value)) {
      this.configurationService.productClass = this.isProPlusThickness(value) ? ProductClass.PROPLUS : ProductClass.PRO;
    } else {
      this.configurationService.productClass = ProductClass.STANDARD;
    }
  }

  isProThickness(thickness: number) {
    return this.proThicknesses.includes(thickness);
  }

  isProPlusThickness(thickness: number) {
    return this.proPlusThicknesses.includes(thickness);
  }

  isStandardThickness(thickness: number) {
    const isStandardThickness: boolean = !this.isProThickness(thickness) && !this.isProPlusThickness(thickness);
    return isStandardThickness;
  }

  openClassification(event: Event, thickness: number) {
    const productClass: ProductClass = this.isProPlusThickness(thickness) ? ProductClass.PROPLUS : ProductClass.PRO;    
    this.productClassificationService.openClassificationURL(productClass);
  }
}
